import React, { Component } from "react";
import { Button } from "../components/Button";
import Select from "../components/Select";
import Input from "../components/Input";
import LimitedSelect from "../components/LimitedSelect";
import MunicipalitySelect from "../components/MunicipalitySelect";
import { pesticideInstructorOperationRightsOptions, pesticideInstructorEducationAreaOptions } from "../constants";
import { FormattedMessage } from "react-intl";
import "./SearchForm.css";

export class SearchForm extends Component {
  submitForm = event => {
    event.preventDefault();
    this.props.fetch(0);
  };

  render() {
    const {
      isFormValid,
      locale,
      searching,
      searchText,
      selectedMunicipalities,
      updateMunicipalities,
      selectedOperationRights,
      updateOperationRights,
      selectedEducationAreas,
      updateEducationAreas,
      updateSearchText,
      resetForm,
    } = this.props;

    return (
      <form className='searchForm' onSubmit={this.submitForm}>
        <div className='searchControls'>
          <div className='searchInputContainer'>
            <label>
              <FormattedMessage tagName='label' id='common.person' />
              <Input
                type='text'
                placeholder='pesticideInstructorSearch.personSearchPlaceholder'
                value={searchText}
                onChange={updateSearchText}
              />
            </label>
          </div>
          <div className='searchInputContainer'>
            <label>
              <FormattedMessage tagName='label' id='common.municipalities' />
              <MunicipalitySelect
                selectedMunicipalities={selectedMunicipalities}
                onChange={updateMunicipalities}
                maxSelections={5}
                locale={locale}
              />
            </label>
          </div>
        </div>
        <div className='searchControls'>
          <div className='searchInputContainer'>
            <label>
              <FormattedMessage tagName='label' id='common.competency' />
              <Select
                onChange={updateOperationRights}
                options={pesticideInstructorOperationRightsOptions}
                placeholder="pesticideInstructorSearch.operationRightsPlaceholder"
                value={selectedOperationRights}
                hideSelectedOptions={false}
              />
            </label>
          </div>

          <div className='searchInputContainer'>
            {selectedOperationRights.value === "KTT" && <div>
              <label>
                <FormattedMessage tagName='label' id='pesticideInstructorSearch.educationAreas' />
                <LimitedSelect
                  onChange={updateEducationAreas}
                  options={pesticideInstructorEducationAreaOptions[locale]}
                  placeholder="pesticideInstructorSearch.educationAreaPlaceholder"
                  value={selectedEducationAreas}
                />
              </label>
            </div>
            }
          </div>

        </div>
        <div className='searchButtonContainer'>
          <div className='validatorMessage' role='alert'>
            {!!!isFormValid() && <FormattedMessage id='pesticideInstructorSearch.inputError' />}
          </div>
          <Button className='clearLink' onClick={resetForm}>
            <FormattedMessage id='common.clearForm' />
          </Button>
          <Button
            className='searchButton'
            type='submit'
            primary
            search
            disabled={searching || !isFormValid()}
          >
            <FormattedMessage id='common.search' />
          </Button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/PesticideInstructorSearch/SearchForm.js